import { useDeleteAccount } from '@/hooks/api';
import { Button, Checkbox, cn, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useState } from 'react';
import type { StepNavigation } from './models';

const applications = [
  { title: 'NOS TV', src: '/images/nos/app-nos-tv.svg' },
  { title: 'NOS Net', src: '/images/nos/app-nos-net.svg' },
  { title: 'NOS Cinemas', src: '/images/nos/app-cinemas.svg' },
  { title: 'NOS Kids', src: '/images/nos/app-nos-kids.svg' },
  { title: 'NOS Safe Net', src: '/images/nos/app-nos-safe-net.svg' },
  { title: 'APP NOS', src: '/images/nos/app-nos-white.svg' },
  { title: 'NOS', src: '/images/nos/app-nos-securitas.svg' },
];

export function SettingsDeleteAccountConfirmSection(_: Readonly<StepNavigation>) {
  const { t } = useI18n();
  const [confirmed, setConfirmed] = useState(false);
  const { mutate: deleteAccount, isPending } = useDeleteAccount();

  return (
    <div className="flex h-full flex-col gap-6">
      <div className="flex flex-col gap-6">
        <span className="text-nos-neutral-900 font-text-p1">
          {t('Common.DeleteAccount.Confirm.Description')}
        </span>

        <div className="flex flex-wrap items-center justify-center gap-6 rounded-md bg-nos-neutral-100 p-6">
          {applications.map((app) => (
            <div
              key={app.title}
              className="flex size-14 items-center justify-center overflow-hidden rounded-xl"
            >
              <img
                src={app.src}
                alt={app.title}
                height={51}
                width={51}
                className="size-full object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          ))}
        </div>

        <span className="font-medium text-nos-neutral-900 font-text-p1">
          {t('Common.DeleteAccount.Confirm.Disclaimer')}
        </span>
      </div>

      <div className="mt-auto flex flex-col gap-6 pb-4">
        <div className="flex cursor-pointer items-center gap-3">
          <Checkbox
            id="delete-account-confirm"
            skin="light"
            checked={confirmed}
            onChange={() => setConfirmed((prev) => !prev)}
            data-tid="checkbox-delete-account-confirm"
          />
          <span className="text-nos-neutral-900 font-text-p2">
            {t('Common.DeleteAccount.Confirm.Checkbox')}
          </span>
        </div>

        <Button
          skin="light"
          variant="primary"
          disabled={!confirmed || isPending}
          className={cn('w-full tablet:w-fit', confirmed && 'bg-nos-red text-nos-neutral-0')}
          onClick={() => deleteAccount(undefined)}
          data-tid="button-delete-account"
        >
          {isPending
            ? t('Common.DeleteAccount.Confirm.Deleting')
            : t('Common.DeleteAccount.Confirm.Button')}
        </Button>
      </div>
    </div>
  );
}
